import { Carousel, CarouselContent, CarouselItem } from "../ui/carousel";
import { Testimonials } from "../ui/Testimonials";
import { Partners } from "../ui/Partners";
import { useState, useEffect } from "react";
import slide1 from "@/assets/images/slide1.jpg";
import slide4 from "@/assets/images/slide4.jpg";

const Home = () => {
  const [current, setCurrent] = useState(0);

  const carousel = [
    {
      id: 1,
      image: slide1,
      quote:
        "Il est essentiel que tous les fonctionnaires, où qu'ils se trouvent, aient accès aux mêmes ressources et opportunités pour se former et se développer professionnellement.",
      author: "Mme Anne Désirée OULOTO",
      poste:
        "Ministre d'État, Ministre de la Fonction Publique et de la Modernisation de l'Administration",
    },
    {
      id: 2,
      image: slide4,
      quote:
        "Performance et excellence : les maîtres-mots de notre administration publique.",
      author: "Mme Anne Désirée OULOTO",
      poste:
        "Ministre d'État, Ministre de la Fonction Publique et de la Modernisation de l'Administration",
    },
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrent((prev) => (prev + 1) % carousel.length);
    }, 5000);
    return () => clearInterval(interval);
  }, [carousel.length]);

  const handleDotClick = (index: number) => {
    setCurrent(index);
  };

  return (
    <div className="w-full min-h-screen pt-6 flex flex-col items-center bg-[#fefaf6]">
      <div className="w-[1350px] mobile:w-[calc(100%-2rem)] tablet:w-[calc(100%-3rem)] mx-auto bg-white rounded-xl overflow-hidden">
        <Carousel className="w-full">
          <CarouselContent>
            {carousel.map((item, index) => (
              <CarouselItem
                key={item.id}
                className={index === current ? "block" : "hidden"}
              >
                <div className="flex relative mobile:flex-col">
                  <div className="w-[40%] mobile:w-full tablet:w-full p-8 mobile:p-4 tablet:p-4 flex flex-col justify-center relative z-10">
                    <div className="relative">
                      <svg
                        className="w-6 h-6 text-green-600"
                        fill="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path d="M14.017 21v-7.391c0-5.704 3.731-9.57 8.983-10.609l.995 2.151c-2.432.917-3.995 3.638-3.995 5.849h4v10h-9.983zm-14.017 0v-7.391c0-5.704 3.748-9.57 9-10.609l.996 2.151c-2.433.917-3.996 3.638-3.996 5.849h3.983v10h-9.983z" />
                      </svg>
                      <p className="text-3xl mobile:text-xl tablet:text-xl font-semibold mb-6 ml-6 text-green-600 font-condensed">
                        {item.quote}
                      </p>
                      <svg
                        className="w-6 h-6 text-green-600 absolute bottom-6 -right-1"
                        fill="currentColor"
                        viewBox="0 0 24 24"
                        transform="rotate(180)"
                      >
                        <path d="M14.017 21v-7.391c0-5.704 3.731-9.57 8.983-10.609l.995 2.151c-2.432.917-3.995 3.638-3.995 5.849h4v10h-9.983zm-14.017 0v-7.391c0-5.704 3.748-9.57 9-10.609l.996 2.151c-2.433.917-3.996 3.638-3.996 5.849h3.983v10h-9.983z" />
                      </svg>
                    </div>
                    <div className="fixed bottom-0 mobile:relative tablet:relative">
                      <p className="text-xl font-bold mobile:text-lg tablet:text-lg">
                        {item.author}
                      </p>
                      <p className="text-gray-600 pb-4 max-w-[400px] break-words mobile:text-sm tablet:text-sm mobile:pb-0 tablet:pb-0 font-condensed">
                        {item.poste}
                      </p>
                    </div>
                  </div>
                  <div className="w-[60%] mobile:w-full tablet:w-full">
                    <img
                      src={item.image}
                      alt="slides"
                      className="w-full h-full object-cover"
                    />
                  </div>
                </div>
              </CarouselItem>
            ))}
          </CarouselContent>
        </Carousel>
      </div>
      <div className="flex gap-2 mt-6">
        {carousel.map((_, index) => (
          <button
            key={index}
            onClick={() => handleDotClick(index)}
            className={`w-2 h-2 rounded-full ${
              index === current ? "bg-[#41a873]" : "bg-gray-300"
            }`}
          />
        ))}
      </div>
      <div className="w-[1350px] mobile:w-[calc(100%-2rem)] tablet:w-[calc(100%-3rem)] mx-auto bg-white rounded-xl">
        <Testimonials />
      </div>
      <div className="w-[1350px] mobile:w-[calc(100%-2rem)] tablet:w-[calc(100%-3rem)] mx-auto rounded-xl mb-10 mobile:mb-0">
        <Partners />
      </div>
    </div>
  );
};

export default Home;
